import { StatePreV6, StateV6 } from './6_migrate_beibehalten.interface';

export const migrateBeibehaltenFeldAngebot = (
  previousState: StatePreV6,
  newVersion: number,
): StateV6 => {
  const migratedWarenkorb = previousState.warenkorb.map(angebot => {
    return { ...angebot, beibehalten: false };
  });
  const migratedState = {
    ...previousState,
    version: newVersion,
    warenkorb: migratedWarenkorb,
  } as StateV6;
  return migratedState;
};
